import ProductCard from "@/components/ProductCard";
import ProductCardV2 from "@/components/ProductCard/ProductCardV2";
import { CSSProperties } from "react";
import classes from "./ProductList.module.css";

interface Props {
	className?: string;
	style?: CSSProperties;
	loading?: boolean;

	products?: ProductItem[];
	productsV2?: ProductItemV2[];
}

const ProductList = ({
	className,
	style,
	loading = false,

	products = [],
	productsV2 = [],
}: Props) => {
	const classNames = [classes.ProductList, className];

	if (loading && products.length === 0)
		return (
			<div className="w-full py-10 flex">
				<div className="mx-auto w-10 h-10 rounded-full border border-gray2 border-b-transparent animate-spin"></div>
			</div>
		);

	return (
		<div className={classNames.join(" ")} style={style}>
			{products.map((product, index) => {
				return (
					<ProductCard
						key={index + "-" + product.id + "-product-card"}
						productItem={product}
						type="lg"
					/>
				);
			})}

			{productsV2.map((product, index) => {
				return (
					<ProductCardV2
						key={index + "-" + product.p_id + "-product-card-v2"}
						productItem={product}
						type="lg"
					/>
				);
			})}

			{loading && <div className={classes.loading}></div>}
		</div>
	);
};

export default ProductList;
